import type {
  AlertType,
} from './types';

const INFO: AlertType = 'info';
const WARNING: AlertType = 'warning';
const DANGER: AlertType = 'danger';
const SUCCESS: AlertType = 'success';

export const alertTypes = {
  INFO,
  WARNING,
  DANGER,
  SUCCESS,
};
